import React from 'react';
import { Text } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { TTemplate } from '@/helpers/createTemplate';
import { FeaturedMatch } from '../components/FeaturedMatch';
import {
  BoxHeadingWrapper,
  FlexWrapper,
  textSloganProps,
} from '@/views/Home/sports/components/Featured/styles/Featured.styles';

const template: TTemplate = {
  wrapper: <FlexWrapper />,
  slogan: {
    wrapper: <BoxHeadingWrapper />,
    body: (
      <Text {...textSloganProps}>
        <FormattedMessage id="promo.sport.featuredSport" />
      </Text>
    ),
    feature: <FeaturedMatch />,
  },
};

export default template;
